import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { isStaleChunkError, reloadForStaleChunk } from './app/core/stale-chunk/stale-chunk';

if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    if (isStaleChunkError(event.reason)) {
      reloadForStaleChunk();
    }
  });
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
